import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyKoalaMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#eef6f0" />
      <circle cx={337} cy={460} r={90} fill="#6d7f6d" />
      <circle cx={457} cy={460} r={90} fill="#6d7f6d" />
      <circle cx={397} cy={520} r={120} fill="#cfd8d2" />
      <g className="mode-copy" transform="translate(48,840)" fill="#122"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyKoalaMode;
